export const environment = {
  production: false,
  apiUrl: 'https://devapi.sjcyouthwellness.com/',
  url: 'siteUrl',
  recaptcha: {
    siteKey: '6Ld_95goAAAAAMCslsUuHZhhB0oFe92t9TTB-NuP',
  },
}
